module.exports = __webpack_public_path__ + "static/heartGray_Desktop-4c2ed511d044149d30bcfb9f20c339c7.png";